import { render, staticRenderFns } from "./RentalAppraisal.vue?vue&type=template&id=45704c6f&scoped=true&"
import script from "./RentalAppraisal.vue?vue&type=script&lang=ts&"
export * from "./RentalAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45704c6f",
  null
  
)

export default component.exports